const {
  GET_COMPANY_DASH_API_START,
  GET_COMPANY_DASH_API_FAILURE,
  GET_COMPANY_DASH_API_SUCCESS,
  GET_COMPANY_DASH_API_SUCCESS_LIFE,
  GET_LOB_PREMIUM_API_START,
  GET_COMPANY_DASH_API_RESET_SUCCESS,
  GET_COMPANY_DASH_API_SUCCESS_Gen,
  GET_LOB_PREMIUM_API_FAIL,
  GET_LOB_PREMIUM_API_SUCCESS_Life,
  GET_LOB_PREMIUM_API_SUCCESS_Gen,
  GET_COMPANY_DASH_API_RESET,
  SHOW_PRIVACY_MODAL,
  GET_EMPLOYEE_API_START,
  GET_EMPLOYEE_API_SUCCESS,
  GET_EMPLOYEE_API_FAIL,
  GET_EMPLOYEE_API_RESET,
  GET_COMPANY_GRAPH,
  GET_COMPANY_GRAPH_SUCCESS,
  GET_COMPANY_GRAPH_FAILED,
  GET_LOB_GRAPH,
  GET_LOB_GRAPH_SUCCESS,
  GET_LOB_GRAPH_FAILED,
  GET_COMPANY_LIFE_GRAPH_SUCCESS,
  GET_LOB_LIFE_GRAPH_SUCCESS
} = require("./constant")


// EMPLOYEE
export const getEmployeeStart = payload => {
console.log(payload)
  return {
    type: GET_EMPLOYEE_API_START,
    payload: payload,
  }
}

export const getEmployeeSuccess = payload => {

  return {
    type: GET_EMPLOYEE_API_SUCCESS,
    payload: payload,
  }
}

export const getEmployeeFail = payload => {

  return {
    type: GET_EMPLOYEE_API_FAIL,
    payload: payload,
  }
}

export const getEmployeeReset = payload => {

  return {
    type: GET_EMPLOYEE_API_RESET,
  }
}

// EMPLOYEE


export const getCompanyDashAPIStart = payload => {

  return {
    type: GET_COMPANY_DASH_API_START,
    payload: payload,
  }
}

export const getCompanyDashAPISuccess = payload => {
  return {
    type: GET_COMPANY_DASH_API_SUCCESS,
    payload: payload,
  }
}


export const getCompanyDashAPISuccessLife = payload => {
  return {
    type: GET_COMPANY_DASH_API_SUCCESS_LIFE,
    payload: payload,
  }
}


export const getCompanyDashAPISuccessGen = payload => {
  return {
    type: GET_COMPANY_DASH_API_SUCCESS_Gen,
    payload: payload,
  }
}


export const getCompanyDashAPIFail = error => {
  return {
    type: GET_COMPANY_DASH_API_FAILURE,
    payload: error,
  }
}

export const getCompanyDashAPIReset = () => {
  return {
    type: GET_COMPANY_DASH_API_RESET
  }
}

// Get Lob API

export const getLOBNetPremiumAPIStart = (payload) => {
  return {
    type: GET_LOB_PREMIUM_API_START,
    payload: payload
  }
}

export const getLOBNetPremiumAPISuccessLife = (payload) => {
  return {
    type: GET_LOB_PREMIUM_API_SUCCESS_Life,
    payload: payload
  }
}

export const getLOBNetPremiumAPISuccessGen = (payload) => {
  return {
    type: GET_LOB_PREMIUM_API_SUCCESS_Gen,
    payload: payload
  }
}


export const getLOBNetPremiumAPIFail = (payload) => {
  return {
    type: GET_LOB_PREMIUM_API_FAIL,
    payload: payload
  }
}

export const showPrivacyModal = () =>{
  return{
    type: SHOW_PRIVACY_MODAL
  }
}

export const getCompanyGraph = (payload) =>{
  return{
    type: GET_COMPANY_GRAPH,
    payload
  }
}


export const getCompanyGraphSuccess = (payload) =>{
  return{
    type: GET_COMPANY_GRAPH_SUCCESS,
    payload
  }
}


export const getCompanyGraphFailed = (payload) =>{
  return{
    type: GET_COMPANY_GRAPH_FAILED,
    payload
  }
}



export const getLOBGraph = (payload) =>{
  return{
    type: GET_LOB_GRAPH,
    payload
  }
}


export const getLOBGraphSuccess = (payload) =>{
  return{
    type: GET_LOB_GRAPH_SUCCESS,
    payload
  }
}


export const getLOBGraphFailed = (payload) =>{
  return{
    type: GET_LOB_GRAPH_FAILED,
    payload
  }
}

export const getCompanyLifeGraphSuccess = (payload) =>{
  return{
    type: GET_COMPANY_LIFE_GRAPH_SUCCESS,
    payload
  }
}


export const getLOBLifeGraphSuccess = (payload) =>{
  return{
    type: GET_LOB_LIFE_GRAPH_SUCCESS,
    payload
  }
}